(function() {
    var mappingForm = document.querySelector('[gr-mapping]');

    if (mappingForm) {
        var selectIndustries = document.querySelector('#slt-industries');
        var selectSolutions = document.querySelector('#slt-solutions');

        mappingForm.addEventListener('submit', function(e) {
            e.preventDefault();
            var industrie = selectIndustries.options[selectIndustries.selectedIndex];
            var solutions = selectSolutions.options[selectSolutions.selectedIndex];
            var url;

            if (industrie.value != 1 && solutions.value == 1) {
                url = industrie.getAttribute('data-url');
                document.location.href = url
            }
            else if (industrie.value == 1 && solutions.value != 1) {
                url = solutions.getAttribute('data-url');
                document.location.href = url
            }
            else if (industrie.value != 1 && solutions.value != 1) {
                url = solutions.getAttribute('data-url');
                document.location.href = url + '?industries=' + industrie.value + '&solutions=' + solutions.value;
            }
        });
    }

})();
